angular.module('app').config(productCategoriesRouting);

function productCategoriesRouting($routeProvider) {
  $routeProvider
    .when('/product_categories', {
      pageTitle: 'PRODUCT_CATEGORIES',
      template: '<product-categories-page></product-categories-page>',
      breadcrumb: {
        label: 'COMPANY_SETTINGS',
        parent: 'bn/company_settings',
      },
      menu: 'settings',
      accessPermission: 'index_productcategory_accountadmin',
      authReq: true,
    })
    .when('/product_categories/new', {
      pageTitle: 'ADD_PRODUCT_CATEGORY',
      template: '<product-category-page></product-category-page>',
      breadcrumb: {
        label: 'PRODUCT_CATEGORIES',
        parent: 'product_categories',
        ajs: true,
      },
      menu: 'settings',
      accessPermission: 'create_productcategory_accountadmin',
      authReq: true,
    })
    .when('/product_categories/:id', {
      params: {
        mode: null,
        activeTab: 0,
      },
      pageTitle: 'EDIT_PRODUCT_CATEGORY',
      template: '<product-category-page></product-category-page>',
      breadcrumb: {
        label: 'PRODUCT_CATEGORIES',
        parent: 'product_categories',
        ajs: true,
      },
      menu: 'settings',
      accessPermission: 'show_productcategory_accountadmin',
      authReq: true,
    });
}

productCategoriesRouting.$inject = ['$routeProvider'];
